<template>
  <v-layout row wrap>
    <v-flex xs12 sm12 md12>
      <v-toolbar class="primary white--text">
        <v-flex xs3>
          <h2 class="headline font-weight-light">Batch Report</h2>
        </v-flex>
        <v-spacer></v-spacer>

        <router-link to="/Dashboard">
          <v-btn icon>
            <v-icon class="white--text">close</v-icon>
          </v-btn>
        </router-link>
      </v-toolbar>

      <!-- firm and Date filter -->
      <v-toolbar class="mb" color="white--text"  style="background : #15155d !important;" flat>
        <v-layout row> 
          <v-flex xs12 sm3 md3>
            <v-menu
              :close-on-content-click="false"
              v-model="datepickerFrom"
              :nudge-right="40"
              class="ist-datepicker"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="fromDate"
                label="From Date"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="fromDate" @input="datepickerFrom = false"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs12 sm3 md3>
            <v-menu
              :close-on-content-click="false"
              v-model="datepickerTo"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              class="ist-datepicker"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="toDate"
                label="To Date"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="toDate" @input="datepickerTo = false"></v-date-picker>
            </v-menu>
          </v-flex>

        </v-layout>
      </v-toolbar>
      <v-layout row wrap>
        <v-flex xs12>
          <v-data-table
            :headers="batchReportHeader"
            :items="getFilteredBatches"
            hide-actions
            class="elevation-1 dashboardHead"
          >
            <template slot="items" slot-scope="props">
              <td>
                <v-icon @click="openInvoice(props.item)" color="primary"
                  >remove_red_eye</v-icon
                >
              </td>
              <td>
                <b>{{ props.item["batchNumber"] }}</b>
              </td>
              <td>
                <b v-if="props.item['manufacturingDate']">{{
                  new Date(props.item["manufacturingDate"])
                    .toISOString()
                    .substr(0, 10)
                }}</b>
              </td>
              <td>
                <b v-if="props.item['expiryDate']">{{
                  new Date(props.item["expiryDate"]).toISOString().substr(0, 10)
                }}</b>
              </td>
              <td>
                <b class="info--text font-weight-bold">{{
                  props.item["quantity"]
                }}</b>
              </td>
            </template>
            <template slot="no-data">No Items</template>
          </v-data-table>
        </v-flex>
      </v-layout>
      <v-dialog
        v-model="viewBatchDialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="viewBatchDialog = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-data-table
            :headers="headers"
            :items="filteredInvoices"
            class="elevation-1"
          >
            <template slot="items" slot-scope="props">
              <td class="text-xs-left nowrap">
                <v-icon @click="openProd(props.item)" color="primary"
                  >remove_red_eye</v-icon
                >
              </td>
              <td class="text-xs-left nowrap">
                <b>{{
                  new Date(props.item.date).toLocaleDateString("en-GB") || "-"
                }}</b>
              </td>
              <td class="text-xs-left nowrap">
                <b>{{ props.item.buyerName || "-" }}</b>
              </td>
              <td class="text-xs-left">
                <b>{{ props.item.invoiceId || "-" }}</b>
              </td>
              <td class="text-xs-left nowrap">
                <b class="font-weight-bold success--text">{{
                  props.item.totalAmount || 0 | amount
                }}</b>
              </td>
              <td class="text-xs-left nowrap">
                <b>{{
                  Number.parseFloat(props.item.totalAmount) -
                    Number.parseFloat(props.item.GSTTotal) || 0 | amount
                }}</b>
              </td>
              <td class="text-xs-left nowrap">
                <b>{{ props.item.GSTTotal || 0 | amount }}</b>
              </td>
              <td class="text-xs-left nowrap">
                <b>{{ props.item.discountAmount || 0 | amount }}</b>
              </td>
              <td class="text-xs-left">
                <b class="font-weight-bold primary--text">{{
                  props.item.paidAmount || 0 | amount
                }}</b>
              </td>
              <td class="text-xs-left">
                <b class="font-weight-bold error--text">{{
                  props.item.remainingAmount || 0 | amount
                }}</b>
              </td>
              <td class="text-xs-left nowrap">
                <b>{{ props.item.duration || "-" }}</b>
              </td>
              <td class="text-xs-left nowrap">
                <b>{{ props.item.daysLeft || "-" }}</b>
              </td>
              <td class="text-xs-left nowrap">
                <b>{{ props.item.paymentType || "-" }}</b>
              </td>
              <td class="text-xs-left nowrap">
                <b>{{ props.item.status || "-" }}</b>
              </td>
              <td class="text-xs-left nowrap">
                <b>{{ props.item.gstType || "-" }}</b>
              </td>
              <td class="text-xs-left nowrap">
                <b>{{ props.item.mobile || "-" }}</b>
              </td>
              <td class="text-xs-left nowrap">
                <b>{{ props.item.tehsil || "-" }}</b>
              </td>
              <td class="text-xs-left nowrap">
                <b>{{ props.item.district || "-" }}</b>
              </td>
              <td class="text-xs-left nowrap">
                <b>{{ props.item.state || "-" }}</b>
              </td>
              <td class="text-xs-left nowrap">
                <b>{{ props.item.firmName || "-" }}</b>
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog" width="800" persistent>
        <v-card>
          <v-card-title class="headline primary--text" primary-title>
            Product List
            <v-spacer></v-spacer>
            <v-btn icon dark @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text>
            <v-data-table
              :headers="invoiceProductListHeader"
              :items="selectedInvoice.items"
              class="elevation-1 dashboardHead"
            >
              <template slot="items" slot-scope="props">
                <td>
                  <b>{{ props.item["productName"] }}</b>
                </td>
                <td>
                  <b>{{ props.item["HSN_code"] }}</b>
                </td>
                <td>
                  <b>{{ props.item["rate"] }}</b>
                </td>
                <td>
                  <b>{{ props.item.taxableGST_rate }}</b>
                </td>
                <td>
                  <b>{{ props.item["productUnit"] }}</b>
                </td>
                <td>
                  <b>{{ props.item["quantity"] }}</b>
                </td>
              </template>
              <template slot="no-data">No Items</template>
            </v-data-table>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="dialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
export default {
  data() {
    return {
      batchReportHeader: [
        { text: "View", value: "batch" },
        { text: "Batch", value: "batch" },
        { text: "Manufacturing Date", value: "manuDate" },
        { text: "Expiry Date", value: "expiryDate" },
        { text: "Quantity", value: "quantity" },
      ],
       headers: [
        { text: "Products", value: "action" },
        { text: "Date", value: "date", sortable: true },
        { text: "Buyer Name", value: "Father Name" },
        { text: "Invoice ID", value: "Block" },
        { text: "Total Amount", value: "totalCurrentAmount" },
        { text: "Basic Amount", value: "basic" },
        { text: "GST", value: "GST" },
        { text: "Discount", value: "totalCurrentAmount" },
        { text: "Paid Amount", value: "Tehsil" },
        { text: "Due Amount", value: "District" },
        { text: "Duration (in Days)", value: "abs" },
        { text: "Days Left", sortable: true, value: "daysLeft" },
        { text: "Payment Type", value: "Identity Number" },
        { text: "Status", value: "Mobile" },        
        { text: "GST type", value: "gst type" },
        { text: "Mobile", value: "mobile" },
        { text: "Tehsil", value: "tehsil" },
        { text: "District", value: "district" },
        { text: "State", value: "state" },        
        { text: "Firm Name", value: "Village" },
      ],
      invoiceProductListHeader: [
        { text: "Product Name", value: "productName" },
        { text: "HSN code", value: "HSN" },
        { text: "Product rate", value: "rate" },
        { text: "GST %", value: "GST Rate" },
        { text: "Unit", value: "Unit" },
        { text: "Quantity", value: "quantity" },
      ],
      filteredInvoices: [],
      viewBatchDialog: false,
      selectedInvoice: {
          items : []
      },
      dialog: false,
      toDate: null,
      fromDate: null,
      datepickerFrom: null,
      datepickerTo: null,
    };
  },
  created() {
    this.$bindAsArray(
      "invoices",
      this.$root.$firebaseRefs.invoice
        .orderByChild("brandFinYear")
        .equalTo(this.brandFinYear)
    );
    this.$bindAsArray(
      "batches",
      this.$root.$firebaseRefs.batchTransaction
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
    this.$bindAsArray(
      "products",
      this.$root.$firebaseRefs.products
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand", "finYear","brandFinYear"]),

    getFilteredBatches() {
      let results = [];
      results.push({
        batchNumber: "No Batch Assigned",
        quantity: 0,
        invoices: [],
      });
      let filteredInvoices = this.invoices.filter((item) => {
        return item["brand"] === this.selectedBrand && item.deleted != true;
      });
      this.batches.map(it =>{
          results.push({
            batchNumber: it.batchNumber,
            quantity: it.openingQuantity || 0,
            invoices: [],
            manufacturingDate : it.manufacturingDate,
            expiryDate : it.expiryDate,
            id : it['.key']
        });
      })
      filteredInvoices.forEach((element) => {
        element.items && element.items.map((item) => {
          if (!item.batchId) {
            let index = results.findIndex(
              (r) => r.batchNumber == "No Batch Assigned"
            );
            results[index].quantity += element.isBuyer
              ? -item.quantity
              : item.quantity;

            results[index].invoices.push(element);
          } else {
            let index = results.findIndex((r) => r["id"] == item.batchId);
            if (index && index > -1) {
              results[index].quantity += element.isBuyer
                ? -item.quantity
                : item.quantity;
              results[index].invoices.push(element);
            }
          }
        });
      });
      return results.filter(item => ((this.fromDate ? item.expiryDate >= new Date(this.toDate).getTime() : true) && (this.toDate ? item.expiryDate <= new Date(this.toDate).getTime() : true)));
    },
    
  },
  methods: {
    getProductName(key) {
      return this.products.find((item) => item[".key"] == key).name;
    },
    openInvoice(item) {
      this.filteredInvoices = item.invoices;
      this.viewBatchDialog = true;
    },
    openProd(invoice) {
      this.selectedInvoice = invoice;
      this.dialog = true;
    },
  },
};
</script>

<style >
.theme--light div.select-firm .v-icon {
  color: white;
}
.theme--light div.select-firm .v-label {
  color: white;
}
.theme--light div.select-firm .v-input__slot:before {
  border-color: white !important;
}
div.select-firm .v-select__selection--comma {
  color: white;
}

.disabledCard {
  background: lightgray;
}

.ist-datepicker .v-icon,
.ist-datepicker .v-label,
.ist-datepicker input {
  color: white !important;
}

.ist-datepicker .v-input__slot:before {
  border-color: white !important;
}

.fl2-table {
  border-radius: 5px;
  font-size: 12px;
  font-weight: normal;
  border: none;
  border-collapse: collapse;
  width: 100%;
  max-width: 100%;
  white-space: nowrap;
  background-color: white;
}

.fl2-table td,
.fl2-table th {
  text-align: center;
  padding: 8px;
}

.fl2-table td {
  border: 1px solid #000000;
  font-size: 12px;
}

.fl2-table thead th {
  color: #ffffff;
  background: #15155d;
  border: 1px solid white;
}

.fl2-table tr:nth-child(even) {
  background: #f8f8f8;
}
</style>



// WEBPACK FOOTER //
// src/components/Informations/BatchReport/BatchReport.vue